import { Actions, ofType } from '@ngrx/effects';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { SET_CURRENT_CAMPAIGN } from 'app/_state/campaign-context/campaign-context-actions';

import { AppPersistantStateService, StoreNames } from '../app-state.service';
import { PersistantStateHook } from './persistant-state-hook-manager.service';
import { isNilOrEmpty } from 'helpers';

export class SaveCurrentCampaignStateHook implements PersistantStateHook {
  private _disposer: Subject<any>;

  attach(actions: Actions, appPersistantStateService: AppPersistantStateService) {
    this._disposer = new Subject<any>();

    actions.pipe(
      ofType(SET_CURRENT_CAMPAIGN),
      takeUntil(this._disposer)
    ).subscribe(
      (update) => {
        if (isNilOrEmpty(update?.payload)) {
          appPersistantStateService.clear(StoreNames.CurrentCampaign);
        } else {
          appPersistantStateService.update(StoreNames.CurrentCampaign, update.payload);
        }
      },
      (err) => {
        console.error(err);
      },
      () => { /* Disposed */ }
    );
  }

  detach() {
    this._disposer.next(null);
    this._disposer.complete();
  }
}
